var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrush = function SvgTrush(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71484 7.63281H23.2844",
    stroke: "#F1585E",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87247 7.63152V5.50912C9.87217 4.94942 10.089 4.41142 10.4773 4.00832C10.6669 3.81217 10.894 3.65608 11.145 3.54931C11.3961 3.44253 11.666 3.38724 11.9389 3.38672H16.0549C16.3264 3.38652 16.5951 3.44178 16.8445 3.54912C17.0969 3.65572 17.3254 3.81187 17.5165 4.00832C17.708 4.20751 17.8601 4.44124 17.9645 4.69712C18.0696 4.95484 18.1229 5.23078 18.1213 5.50912V7.63152H9.87247ZM21.2237 7.63152V22.4883C21.224 23.048 21.0072 23.586 20.6189 23.9891C20.4316 24.1904 20.2056 24.3516 19.9544 24.4633C19.7033 24.5749 19.4321 24.6346 19.1573 24.6387H8.84207C8.56934 24.6376 8.29959 24.582 8.04861 24.4753C7.79763 24.3685 7.57048 24.2128 7.38047 24.0171C6.99372 23.6135 6.77888 23.0754 6.78127 22.5163V7.63152H21.2237Z",
    stroke: "#F1585E",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9395 12.9375V19.3047",
    stroke: "#F1585E",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0605 12.9375V19.3047",
    stroke: "#F1585E",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrush, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Trush.0e7c6ae3.svg";
export { ForwardRef as ReactComponent };